// Services accordion
const accordion = require(MODULES_PATH + '/accordion');

new accordion({
    selector: '.services-accordion',
    duration: 400,
    openOnInit: [],
});
